import React, { useState } from 'react';
import { Nav, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from 'reactstrap';
import ModuleInstanceFilesModal from '../../storageContainer/ModuleInstanceFilesModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { downloadInstanceLogs } from '../../../store/ModuleInstanceAction';
import { useTranslation } from 'react-i18next';


interface DownloadFilesForInstanceProps {
    moduleInstanceId: string
    fileDownloadEnabled: boolean
    moduleId: string
    completed: boolean
}

const DownloadFilesForInstance = (props: DownloadFilesForInstanceProps) => {
    const [open, setOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState<{ [key: string]: boolean }>({});

    const { t } = useTranslation('configuration');

    const downloadFile = (moduleInstanceId: string) => {
        downloadInstanceLogs(props.moduleId, moduleInstanceId, {});
    }

    const renderDropdownMenu = (moduleInstanceId: string, completed: boolean) => {
        const fileDownloadEnabled = props.fileDownloadEnabled;
        return (
            <Nav className="right">
                {(completed || fileDownloadEnabled) &&
                    <Dropdown nav isOpen={dropdownOpen[moduleInstanceId]} toggle={() => setDropdownOpen({ [moduleInstanceId]: !dropdownOpen[moduleInstanceId] })}>
                        <DropdownToggle nav style={{ display: 'inline' }}>
                            <FontAwesomeIcon icon="ellipsis" className="icon" title={t('moduleInstanceRun.dropdown.htmlTitle')} />
                        </DropdownToggle>
                        <DropdownMenu>
                            {completed && <DropdownItem header><span className="pointer" onClick={() => downloadFile(props.moduleInstanceId)}>{t('moduleInstanceRun.dropdown.downloadLogs')} <FontAwesomeIcon icon="file-download" className="icon" /></span></DropdownItem>}
                            {fileDownloadEnabled && <DropdownItem header><span className="pointer" onClick={() => setOpen(true)}>{t('moduleInstanceRun.dropdown.downloadFiles')} <FontAwesomeIcon icon="folder" color="orange" className="icon" /></span></DropdownItem>}
                        </DropdownMenu>
                    </Dropdown>
                }
            </Nav>
        )
    }

    const renderModal = () => (
        <ModuleInstanceFilesModal
            moduleInstanceId={props.moduleInstanceId}
            isOpen={open}
            toggleModal={() => setOpen(!open)}
        />);

    return (<>
        {renderDropdownMenu(props.moduleInstanceId, props.completed)}
        {open && renderModal()}
    </>);
}

export default DownloadFilesForInstance;
